import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'
import useSvgColors from '@/hooks/useSvgColors'

const HistogramChartIcon = ({ color, onClick }) => {
  const {
    fill,
  } = useSvgColors(color)

  return (
    <svg onClick={onClick} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={fill} className="svgFill" d="M18 6H14V18H18V6Z" />
      <path fill={fill} className="svgFill" d="M11 0H7V18H11V0Z" />
      <path fill={fill} className="svgFill" d="M4 9H0V18H4V9Z" />
    </svg>
  )
}

HistogramChartIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

HistogramChartIcon.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(HistogramChartIcon)
